// Copyright (c) 2024 - Present. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import logo from '@/assets/logo.png';
import { ExternalLink, InternalLink } from '@/components/link';
import { Box, Container, Paper, Stack, Typography } from '@mui/material';
import { createFileRoute } from '@tanstack/react-router';

import { useHubspot } from 'src/hooks/use-hubspot';

export const Route = createFileRoute('/register')({
  component: ContactRoute,
});
const MARKETING_URL = 'https://www.hardfin.com/';

function ContactRoute() {
  const formId = 'contactForm';
  useHubspot(formId, {
    region: 'na1',
    portalId: '19572841',
    formId: '2e5f130e-0311-4ca9-bf4d-eefc97599c04',
    target: `#${formId}`,
  });

  return (
    <Box
      display="grid"
      gridTemplateColumns="1fr"
      gridTemplateRows="1fr auto"
      alignItems="center"
      justifyContent="center"
      bgcolor="grey.50"
      width="100dvw"
      height="100dvh"
    >
      <Container component="main" maxWidth="sm">
        <Paper
          elevation={16}
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Stack
            sx={{
              paddingTop: '4rem',
              paddingBottom: '2rem',
            }}
            minWidth="30rem"
            alignItems="center"
            justifyContent="center"
          >
            <ExternalLink href={MARKETING_URL}>
              <img alt="logo" src={logo} height="40px" width="auto" />
            </ExternalLink>
            <Box
              sx={{
                backgroundColor: 'background.paper',
              }}
            >
              <Box
                sx={{
                  paddingBottom: '1rem',
                  width: '420px',
                }}
              >
                <Typography
                  sx={{ py: 3 }}
                  color="textSecondary"
                  variant="body1"
                >
                  Ready to get started? Enter your information to access the{' '}
                  <InternalLink to="/">Hardfin platform</InternalLink> or{' '}
                  <ExternalLink href="https://www.hardfin.com/">
                    learn more about Hardfin
                  </ExternalLink>{' '}
                  first.
                </Typography>
              </Box>
              <div id={formId} />
            </Box>
          </Stack>
        </Paper>
      </Container>
    </Box>
  );
}
